/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3B1cmNoYXNpbmcvZGVzaWducy1saXN0L2Rlc2lnbnMtbGlzdC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9vcmlvbi9Qcm9qZWN0cy9zaW1wbGljaXR5RW5naW5lL3ZhbG11c3QvdmFsbXVzdGZlL3NyYy9hcHAvYWdhdGV4dHNjcmVlbnMvcHVyY2hhc2luZy9kZXNpZ25zLWxpc3QvZGVzaWducy1saXN0LmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/purchasing/designs-list/designs-list.component.scss.shim.ngstyle.ts